import React from 'react';
import PropTypes from 'prop-types';
import {filterValue, filterValueWithDefault} from './filterValue';
import {localeFormatter} from '../../functions/textFormatter';

export const LocalizedOutputValue = ({ style, name, prefix, resource }, context) => (
  <span style={style}>{
    filterValue({
      resource,
      name,
      formatter: localeFormatter(context.locale)(prefix),
    })
  }</span>
);

LocalizedOutputValue.contextTypes = {
  locale: PropTypes.string,
};

export const ConcatenateOutputValue = ({ style, resource, names, formatter }) => (
  <span style={style}>
    {names.map(name => filterValue({ resource, name, formatter })).join(' ')}
  </span>
);

const OutputValue = ({ style, className, defaultValue, hideIf, ...other }) => {
  const value = defaultValue ? filterValueWithDefault(defaultValue, other) : filterValue(other);
  const hidden = hideIf !== undefined && hideIf !== null && hideIf === value;
  const finalStyle = hidden ? {} : style;
  const finalClassName = hidden ? '' : className;
  return (
    <span style={finalStyle} className={finalClassName}>
      {hidden ? '' : value}
    </span>
  );
};

export const OutputValueAcknowledgment = ({ style, className, defaultValue, hideIf, ...other }) => {
  const value = defaultValue ? filterValueWithDefault(defaultValue, other) : filterValue(other);
  const hidden = hideIf !== undefined && hideIf !== null && hideIf === value;
  if(other.resource != undefined && other.resource.hasAcknowledgmentExpired != undefined){
    style = other.resource.hasAcknowledgmentExpired ? {color: 'white', backgroundColor: '#E8212E'} : {}
  }
  const finalStyle = hidden ? {} : style;
  const finalClassName = hidden ? '' : className;
  return (
    <span style={finalStyle} className={finalClassName}>
      {hidden ? '' : value}
    </span>
  );
};

export default OutputValue;



// WEBPACK FOOTER //
// ./src/main/components/output/OutputValue.js